export default "__VITE_ASSET__c2d07b7a__"